import React, { useState, useEffect } from "react";
import debounce from "lodash.debounce";

import { string, array, shape, arrayOf, bool, object } from "prop-types";

import ListItem from "../../ListItem/ListItem.jsx";

const propTypes = {
  reversed: bool,
  results: arrayOf(
    shape({
      imageSrcWide: string,
      imageSrcSquare: string,
      title: string,
      taxonomy: array,
      contentUrl: string,
    }),
  ),
  focusRef: object,
};

const SimpleGrid = (props) => {
  const { reversed, results, focusRef } = props;

  const breakpoint = 779;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);
  const [leftResults, setLeftResults] = useState([]);
  const [rightResults, setRightResults] = useState([]);

  useEffect(() => {
    if (results.length === 1) {
      setLeftResults(results);
      setRightResults([]);
    } else {
      if (isMobile) {
        const half = Math.ceil(results.length / 2);
        setLeftResults(results.slice(0, half));
        setRightResults(results.slice(half, results.length));
      } else {
        setLeftResults(results.filter((r, i) => i % 2 === 0));
        setRightResults(results.filter((r, i) => (i + 1) % 2 === 0));
      }
    }
  }, [results, isMobile]);

  useEffect(() => {
    const handleResize = debounce(() => {
      // render is only called if this actually changes state.
      setIsMobile(window.innerWidth <= breakpoint);
    }, 100);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  // no results passed.
  if (!results || results.length < 1) {
    return null;
  }

  const renderWide = (firstColumn) => (
    <div className="simple-grid__col simple-grid__col--wide">
      {leftResults &&
        leftResults.map((result, i) => (
          <div key={result.key} className="simple-grid__item">
            <ListItem
              {...result}
              imagePosition=""
              media={result.imageSrcSquare}
              sizes="570px"
              link={{
                href: result.contentUrl,
                text: "",
              }}
              focusRef={firstColumn && i === 0 ? focusRef : null}
            />
          </div>
        ))}
    </div>
  );

  const renderNarrow = (firstColumn) => (
    <div className="simple-grid__col simple-grid__col--narrow">
      {rightResults &&
        rightResults.map((result, i) => (
          <div key={i} className="simple-grid__item">
            <ListItem
              {...result}
              imagePosition=""
              media={i % 2 === 0 ? result.imageSrcSquare : result.imageSrcWide}
              sizes={i % 2 === 0 ? "570px" : "370px"}
              link={{
                href: result.contentUrl,
                text: "",
              }}
              focusRef={firstColumn && i === 0 ? focusRef : null}
            />
          </div>
        ))}
    </div>
  );

  return (
    <section className="simple-grid">
      <div className="simple-grid__container">
        {reversed ? renderNarrow(true) : renderWide(true)}
        {reversed ? renderWide() : renderNarrow()}
      </div>
    </section>
  );
};

SimpleGrid.propTypes = propTypes;
export default SimpleGrid;
